<script setup lang="ts">
import type { SearchFieldProps } from '@formwerk/core'
import { useSearchField } from '@formwerk/core'

const props = defineProps<SearchFieldProps>()

const {
  inputProps,
  fieldValue,
  setValue,
} = useSearchField(props)

const inputValue = ref(fieldValue.value)
const debouncedValue = refDebounced(inputValue, 500)

watch(debouncedValue, (v) => {
  setValue(v)
})

watch(fieldValue, (val) => {
  if (val !== inputValue.value)
    inputValue.value = val
})
</script>

<template>
  <div class="search">
    <TextField
      v-model="inputValue"
      :label="label || 'Search'"
      type="text"
    />
    <input
      v-bind="inputProps"
      :value="debouncedValue"
      type="search"
      class="sr-only"
      tabindex="-1"
      aria-hidden="true"
      autocomplete="off"
      readonly
    >
  </div>
</template>
